import {useSelector} from 'react-redux';

import * as requestSelectors from '../../../redux/requestPage/request/selectors';

export const useRequestCurrentLangCommunication = () => {
    return useSelector(requestSelectors.getCurrentLangCommunication);
};
